import { render } from "./Tax.vue?vue&type=template&id=d9afd6b8&scoped=true"
import script from "./Tax.vue?vue&type=script&lang=js"
export * from "./Tax.vue?vue&type=script&lang=js"

import "./Tax.vue?vue&type=style&index=0&id=d9afd6b8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9afd6b8"]])

export default __exports__